export default "/images/exit-icon.svg?750f226df8f5fcb947f2fec8b30cd917";